import { render, staticRenderFns } from "./authorizedUser.vue?vue&type=template&id=1d4bb7c1&scoped=true"
import script from "./authorizedUser.vue?vue&type=script&lang=js"
export * from "./authorizedUser.vue?vue&type=script&lang=js"
import style0 from "./authorizedUser.vue?vue&type=style&index=0&id=1d4bb7c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4bb7c1",
  null
  
)

export default component.exports